var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCopyPaste = function SvgCopyPaste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2 0q.16.56.24 1.04.24 1.44.4 2.96h-2a23 23 0 0 0-.24-2H2.4v.32A31.6 31.6 0 0 0 2 7.36q0 2.56.32 4.64H4v2H.8l-.24-.72q-.24-.96-.32-2.24Q0 9.36 0 7.4t.24-3.88Q.32 2.16.56.96L.8 0zM20 13.36q0-1.92-.24-3.84-.08-1.36-.32-2.56L19.2 6H6.8l-.24.96q-.24 1.2-.32 2.56Q6 11.44 6 13.4t.24 3.64q.08 1.28.32 2.24l.24.72h12.4l.24-.72q.24-.96.32-2.24.24-1.68.24-3.68M8.4 8.32V8h9.2v.32q.4 2.4.4 5T17.68 18H8.32Q8 15.92 8 13.32t.4-5"
  })));
};
export default SvgCopyPaste;